import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	computed,
	OnInit,
	signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { combineLatest, tap } from 'rxjs';
import { AdviceService } from '../../services/advice.service';
import { fetchAllArticles, fetchFeatured } from '../../data-access/+state/advice.actions';
import {
	getStateAdviceAllArticles,
	getStateAdviceFeatured,
} from '../../data-access/+state/advice.selectors';
import { SnigelService } from '@uc/web/core';
import { SeoMetadataService } from '@uc/utilities';
import {
	LoadingAnimationComponent,
	LoadingAnimationService,
	SearchComponent,
} from '@uc/shared/ui';
import { MainHeaderComponent, TableSearchComponent } from '@web/shared/ui';
import {
	PromoSlotCtaCardComponent,
	PromoSlotsComponent,
} from '@uc/web/shared/feature/feature-promo-slots';
import { StickyLeadBarRendererComponent } from '@web/shared/feature/feature-sticky-lead-bar';
import { ADVICE_META_DATA } from '../../static/advice.properties';
import { AdviceFeaturedCardComponent } from '../../components/advice-featured-card/advice-featured-card.component';
import { AdviceArticleCardComponent } from '../../components/advice-article-card/advice-article-card.component';
import { AdviceCategoryCardComponent } from '../../components/advice-category-card/advice-category-card.component';

@Component({
	selector: 'uc-advice',
	templateUrl: './advice.component.html',
	imports: [
		CommonModule,
		MainHeaderComponent,
		SearchComponent,
		LoadingAnimationComponent,
		AdviceFeaturedCardComponent,
		AdviceArticleCardComponent,
		AdviceCategoryCardComponent,
		PromoSlotsComponent,
		StickyLeadBarRendererComponent,
		TableSearchComponent,
		PromoSlotCtaCardComponent,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdviceComponent implements OnInit {
	loadingHtml = this._loadingSrv.createPara(2, 3);
	isLoading = true;

	articles!: any;
	featured!: any;
	articleCount = signal(0);

	articles$ = combineLatest([
		this._store.select(getStateAdviceAllArticles),
		this._store.select(getStateAdviceFeatured),
	]).pipe(
		tap((data) => {
			const [all, featured] = data;
			this.articles = all;
			this.featured = featured;
			this.articleCount.set(this._countArticles(all));
			this.isLoading = !all || !featured;
			if (!this.isLoading)
				this._snigelSrv.getAds(['incontent_1_dskt', 'incontent_1_mob']);
			this._cd.detectChanges();
		}),
	);

	categoryMeta = this._adviceSrv.getCategoryMeta();

	tableSearchDescription = computed(
		() =>
			`${this.categoryMeta.length} categories with ${this.articleCount()} articles`,
	);

	constructor(
		private _store: Store,
		private _adviceSrv: AdviceService,
		private _seoSrv: SeoMetadataService,
		private _loadingSrv: LoadingAnimationService,
		private _snigelSrv: SnigelService,
		private _cd: ChangeDetectorRef,
	) {}

	ngOnInit(): void {
		this._seoSrv.updateTitle(ADVICE_META_DATA.title);
		this._seoSrv.updateDescription(ADVICE_META_DATA.description);

		this._store.dispatch(fetchFeatured());
		this._store.dispatch(fetchAllArticles());
	}

	private _countArticles(articles: any) {
		// iterate through object and count length
		let count = 0;
		for (const category in articles) {
			if (articles[category].length > 0) {
				count += articles[category].length;
			}
		}
		return count;
	}
}
